export enum TabMenu {
  NOW_PLAYING = 'now_playing',
  RADIOS = 'radios',
  FAVORITES = 'favorites',
  SETTINGS = 'settings',
  EQUALIZER = 'equalizer',
  COPYRIGHTS_AND_PRIVACY_POLICY = 'copyrights_and_privacy_policy',
}
